import React, { useState } from "react";
import { useStores } from "../../../store";

const Remaining = ({
  title = "Reminder Notifications",
  description = "Configure reminders for pending interviews or tasks",
  initialState = false,
  onToggle,
}) => {
  const { UserStore } = useStores();
  const user = JSON.parse(localStorage.getItem("user"));
  const settings = Array.isArray(user?.additionalSettings)
    ? user.additionalSettings.find(
        (setting) => setting?.name === "reminderNotifications"
      )?.value ?? false
    : false;
  const [isEnabled, setIsEnabled] = useState(settings);

  const handleToggle = async () => {
    const res = await UserStore.UpdateUserStatus({
      additionalSettings: [
        {
          name: "reminderNotifications",
          value: !isEnabled,
        },
      ],
    });
    if (res) {
      setIsEnabled(
        UserStore.userDetails.additionalSettings?.find(
          (setting) => setting?.name === "reminderNotifications"
        )?.value ?? false
      );
    }
  };

  return (
    <div className="border rounded-lg shadow-sm md:p-5 lg:p-5 p-5 bg-gray-50 md:w-full lg:w-full w-[42.5vh]  max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl md:mb-10 lg:mb-10 mb-0">
      <div className="flex items-center justify-between">
        <h1 className="md:font-bold lg:font-bold font-semibold text-base md:text-xl lg:text-xl ">
          {title}
        </h1>
        <button
          onClick={handleToggle}
          className={`w-10 h-5 flex items-center rounded-full p-0 transition-colors duration-300 ${
            isEnabled ? "bg-orange-500" : "bg-gray-300"
          }`}
        >
          <div
            className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
              isEnabled ? "translate-x-5" : "translate-x-0"
            }`}
          ></div>
        </button>
      </div>
      <p className="mt-2 text-gray-500 text-sm md:text-base">{description}</p>
    </div>
  );
};

export default Remaining;
